import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=47f8a42a&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&lang=ts"
export * from "./ServiceConfig.vue?vue&type=script&lang=ts"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=47f8a42a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8a42a",
  null
  
)

export default component.exports